import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent extends BaseControlComponent implements OnInit {
    static componentName = 'CheckboxComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    get contextValue(): any {        
        if (this.isEdit) {
            if (this.componentData.config.useDefaultValue) {                
                return this.componentData.config.defaultValue === "checked";
            }    
            return false;
        }
        return super.contextValue;
    }

    set contextValue(value: any) {
        super.contextValue = value;
    }

    ngOnInit() {
        super.ngOnInit();

        if (!this.isEdit && this.componentData.config.useDefaultValue && this.contextValue === "") {            
            this.contextValue = this.componentData.config.defaultValue === "checked";
        }
    }
}
